import React from "react";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import {
  FEEDBACK_FLOW_DYNAMIC,
  IProductParams,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_BUG_REPORT,
  FEEDBACK_TYPE_FEATURE_REQ,
} from "../../../model";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { appLogger } from "../../../utils";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const CategoryList = (props: any) => {
  appLogger.info({ infoObj: { method: "CategoryList", component: "add-product", fileName: "categoryList.tsx", props: props } });
  const {
    category,
    feedbackType,
    catIndex,
    feedbackFlowType,
    productParams,
    setProductParams,
    errMsg, setErrMsg
  } = props;
  const deleteFeedbackCategory = (catIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (feedbackType === FEEDBACK_TYPE_FEEDBACK) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings
        ) {
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories.splice(
            catIndex,
            1
          );
          setProductParams(temp);
        }
      } else if (feedbackType === FEEDBACK_TYPE_BUG_REPORT) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings
        ) {
          temp.products[0].feedbackAgentSettings.bugSettings.categories.splice(
            catIndex,
            1
          );
          setProductParams(temp);
        }
      } else if (feedbackType === FEEDBACK_TYPE_FEATURE_REQ) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings
        ) {
          temp.products[0].feedbackAgentSettings.featureReqSettings.categories.splice(
            catIndex,
            1
          );
          setProductParams(temp);
        }
      }
    }
  };

  const handleChangeFeedbackCategoryName = (event: any, catIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };

      const deepCopy: IProductParams | undefined = JSON.parse(JSON.stringify(productParams));
      if (feedbackType === FEEDBACK_TYPE_FEEDBACK) {
        if (
          deepCopy &&
          deepCopy.products &&
          deepCopy.products[0] &&
          deepCopy.products[0].feedbackAgentSettings &&
          deepCopy.products[0].feedbackAgentSettings.feedbackSettings
        ) {
          deepCopy.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ].name = event.target.value;
          setProductParams(deepCopy);
          if (errMsg.feedbackCategoryErr &&  event.target.value) {
              const msg = {...errMsg};
              msg.feedbackCategoryErr = null;
              setErrMsg(msg);
          }
        }
      } else if (feedbackType === FEEDBACK_TYPE_BUG_REPORT) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings
        ) {
          temp.products[0].feedbackAgentSettings.bugSettings.categories[
            catIndex
          ].name = event.target.value;
          setProductParams(temp);
          if (errMsg.bugCategoryErr &&  event.target.value) {
            const msg = {...errMsg};
            msg.bugCategoryErr = null;
            setErrMsg(msg);
        }
        }
      } else if (feedbackType === FEEDBACK_TYPE_FEATURE_REQ) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings
        ) {
          temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
            catIndex
          ].name = event.target.value;
          setProductParams(temp);
          if (errMsg.featureCategoryErr &&  event.target.value) {
            const msg = {...errMsg};
            msg.featureCategoryErr = null;
            setErrMsg(msg);
        }
        }
      }
    }
  };

  const deleteFeedbackStdFeedbackText = (catIndex: number, index: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (feedbackType === FEEDBACK_TYPE_FEEDBACK) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks.splice(index, 1);
            setProductParams(temp);
          }
        }
      } else if (feedbackType === FEEDBACK_TYPE_BUG_REPORT) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.bugSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks.splice(index, 1);
            setProductParams(temp);
          }
        }
      } else if (feedbackType === FEEDBACK_TYPE_FEATURE_REQ) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks.splice(index, 1);
            setProductParams(temp);
          }
        }
      }
    }
  };

  const addFeedbackStdFeedbackText = (catIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (feedbackType === FEEDBACK_TYPE_FEEDBACK) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
              catIndex
            ];
          if (!tempCat.feedbacks) {
            tempCat.feedbacks = [];
          }
          tempCat.feedbacks.push("");
          setProductParams(temp);
        }
      } else if (feedbackType === FEEDBACK_TYPE_BUG_REPORT) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.bugSettings.categories[
              catIndex
            ];
          if (!tempCat.feedbacks) {
            tempCat.feedbacks = [];
          }
          tempCat.feedbacks.push("");
          setProductParams(temp);
        }
      } else if (feedbackType === FEEDBACK_TYPE_FEATURE_REQ) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
              catIndex
            ];
          if (!tempCat.feedbacks) {
            tempCat.feedbacks = [];
          }
          tempCat.feedbacks.push("");
          setProductParams(temp);
        }
      }
    }
  };

  const handleChangeFeedbackStdFeedbackText = (
    event: any,
    catIndex: number,
    index: number
  ) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (feedbackType === FEEDBACK_TYPE_FEEDBACK) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings &&
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks[index] = event.target.value;
            setProductParams(temp);
          }
        }
      } else if (feedbackType === FEEDBACK_TYPE_BUG_REPORT) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings &&
          temp.products[0].feedbackAgentSettings.bugSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.bugSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks[index] = event.target.value;
            setProductParams(temp);
          }
        }
      } else if (feedbackType === FEEDBACK_TYPE_FEATURE_REQ) {
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings &&
          temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
            catIndex
          ]
        ) {
          const tempCat =
            temp.products[0].feedbackAgentSettings.featureReqSettings.categories[
              catIndex
            ];
          if (tempCat.feedbacks) {
            tempCat.feedbacks[index] = event.target.value;
            setProductParams(temp);
          }
        }
      }
    }
  };

  const addNegativeFeedbackText = (catIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (!tempCat.negativeFeedbacks) {
          tempCat.negativeFeedbacks = [];
        }
        tempCat.negativeFeedbacks.push("");
        setProductParams(temp);
      }
    }
  };

  const addPositiveFeedbackText = (catIndex: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (!tempCat.positiveFeedbacks) {
          tempCat.positiveFeedbacks = [];
        }
        tempCat.positiveFeedbacks.push("");
        setProductParams(temp);
      }
    }
  };

  const handleChangeNegativeFeedbackText = (
    event: any,
    catIndex: number,
    index: number
  ) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (tempCat.negativeFeedbacks) {
          tempCat.negativeFeedbacks[index] = event.target.value;
          setProductParams(temp);
        }
      }
    }
  };

  const handleChangePositiveFeedbackText = (
    event: any,
    catIndex: number,
    index: number
  ) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (tempCat.positiveFeedbacks) {
          tempCat.positiveFeedbacks[index] = event.target.value;
          setProductParams(temp);
        }
      }
    }
  };

  const deletePositiveFeedbackText = (catIndex: number, index: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (tempCat.positiveFeedbacks) {
          tempCat.positiveFeedbacks.splice(index, 1);
          setProductParams(temp);
        }
      }
    }
  };

  const deleteNegativeFeedbackText = (catIndex: number, index: number) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings &&
        temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
          catIndex
        ]
      ) {
        const tempCat =
          temp.products[0].feedbackAgentSettings.feedbackSettings.categories[
            catIndex
          ];
        if (tempCat.negativeFeedbacks) {
          tempCat.negativeFeedbacks.splice(index, 1);
          setProductParams(temp);
        }
      }
    }
  };

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Card>
        <CardContent>
          <Grid container spacing={2} sx={{ alignItems: "center", mb: 2 }}>
            <Grid item sx={{ flexGrow: 1 }}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Category Name </InputLabel>
                <OutlinedInput
                  type="text"
                  value={category.name}
                  onChange={(event) =>
                    handleChangeFeedbackCategoryName(event, catIndex)
                  }
                  id={`category-name-input-${feedbackType}-${catIndex}`}
                  label="category name"
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Tooltip title="Delete Category" placement="top">
                <CloseIcon
                  className="cursor-pointer"
                  onClick={() => deleteFeedbackCategory(catIndex)}
                />
              </Tooltip>
            </Grid>
          </Grid>

          {/* <Card sx={{ mt: 2 }}>
            <CardContent>
              {category.feedbacks && category.feedbacks.length > 0 && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Grid item sx={{ flexGrow: 1 }}>
                    <Typography className="title">standard feedback</Typography>
                  </Grid>
                </Grid>
              )}
              {category.feedbacks &&
                category.feedbacks.map((feedback: string, index: number) => {
                  return (
                    <Grid
                      container
                      spacing={2}
                      sx={{ alignItems: "center", mb: 2 }}
                      key={index}
                    >
                      <Grid item sx={{ flexGrow: 1 }}>
                        <FormControl
                          className="custom-select"
                          fullWidth
                          hiddenLabel
                        >
                          <OutlinedInput
                            type="text"
                            value={feedback ? feedback : ""}
                            onChange={(event) =>
                              handleChangeFeedbackStdFeedbackText(
                                event,
                                catIndex,
                                index
                              )
                            }
                            id={`stdFeedbackTxt-select-${feedbackType}-${catIndex}_${index}`}
                            inputProps={{
                              "aria-label": "standard feedback text",
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <>
                          <Tooltip
                            title="Delete Standard Feedback Text"
                            placement="top"
                          >
                            <CloseIcon
                              className="cursor-pointer"
                              onClick={() =>
                                deleteFeedbackStdFeedbackText(catIndex, index)
                              }
                            />
                          </Tooltip>
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="button"
                  variant="text"
                  onClick={() => addFeedbackStdFeedbackText(catIndex)}
                  sx={{
                    textTransform: "uppercase",
                  }}
                >
                  <AddIcon />
                  add standard feedback text
                </Button>
              </Grid>
            </CardContent>
          </Card> */}

          <Accordion className="standard-collapse">
            <AccordionSummary
              aria-controls={"standard-content"}
              id={"standard-header"}
            >
              standard feedback
            </AccordionSummary>
            <AccordionDetails>
              {category.feedbacks &&
                category.feedbacks.map((feedback: string, index: number) => {
                  return (
                    <Grid
                      container
                      spacing={2}
                      sx={{ alignItems: "center", mb: 2 }}
                      key={index}
                    >
                      <Grid item sx={{ flexGrow: 1 }}>
                        <FormControl
                          className="custom-select"
                          fullWidth
                          hiddenLabel
                        >
                          <OutlinedInput
                            type="text"
                            value={feedback ? feedback : ""}
                            onChange={(event) =>
                              handleChangeFeedbackStdFeedbackText(
                                event,
                                catIndex,
                                index
                              )
                            }
                            id={`stdFeedbackTxt-select-${feedbackType}-${catIndex}_${index}`}
                            inputProps={{
                              "aria-label": "standard feedback text",
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <>
                          <Tooltip
                            title="Delete Standard Feedback Text"
                            placement="top"
                          >
                            <CloseIcon
                              className="cursor-pointer"
                              onClick={() =>
                                deleteFeedbackStdFeedbackText(catIndex, index)
                              }
                            />
                          </Tooltip>
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="button"
                  variant="text"
                  onClick={() => addFeedbackStdFeedbackText(catIndex)}
                  sx={{
                    textTransform: "uppercase",
                  }}
                >
                  <AddIcon />
                  add standard feedback text
                </Button>
              </Grid>
            </AccordionDetails>
          </Accordion>

          {/* {feedbackFlowType === FEEDBACK_FLOW_DYNAMIC ? (
            <>
              <Card sx={{ mt: 2 }}>
                <CardContent>
                  {category.positiveFeedbacks &&
                    category.positiveFeedbacks.length > 0 && (
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Grid item sx={{ flexGrow: 1 }}>
                          <Typography className="title">
                            positive feedback
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  {category.positiveFeedbacks &&
                    category.positiveFeedbacks.map(
                      (feedback: string, index: number) => {
                        return (
                          <Grid
                            container
                            spacing={2}
                            sx={{ alignItems: "center", mb: 2 }}
                          >
                            <Grid item sx={{ flexGrow: 1 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>feedback text </InputLabel>
                                <OutlinedInput
                                  type="text"
                                  value={feedback ? feedback : ""}
                                  onChange={(event) =>
                                    handleChangePositiveFeedbackText(
                                      event,
                                      catIndex,
                                      index
                                    )
                                  }
                                  id={`posFeedbackTxt-select-${feedbackType}-${catIndex}-${index}`}
                                  label="positive feedback Txt"
                                />
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <>
                                <Tooltip
                                  title="Delete Positive Feedback Text"
                                  placement="top"
                                >
                                  <CloseIcon
                                    className="cursor-pointer"
                                    onClick={() =>
                                      deletePositiveFeedbackText(
                                        catIndex,
                                        index
                                      )
                                    }
                                  />
                                </Tooltip>
                              </>
                            </Grid>
                          </Grid>
                        );
                      }
                    )}
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      type="button"
                      variant="text"
                      onClick={() => addPositiveFeedbackText(catIndex)}
                      sx={{
                        textTransform: "uppercase",
                      }}
                    >
                      <AddIcon />
                      add positive feedback text
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
              <Card sx={{ mt: 2 }}>
                <CardContent>
                  {category.negativeFeedbacks &&
                    category.negativeFeedbacks.length > 0 && (
                      <Grid
                        item
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Grid item sx={{ flexGrow: 1 }}>
                          <Typography className="title">
                            negative feedback
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  {category.negativeFeedbacks &&
                    category.negativeFeedbacks.map(
                      (feedback: string, index: number) => {
                        return (
                          <Grid
                            container
                            spacing={2}
                            sx={{ alignItems: "center", mb: 2 }}
                          >
                            <Grid item sx={{ flexGrow: 1 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>feedback text </InputLabel>
                                <OutlinedInput
                                  type="text"
                                  value={feedback ? feedback : ""}
                                  onChange={(event) =>
                                    handleChangeNegativeFeedbackText(
                                      event,
                                      catIndex,
                                      index
                                    )
                                  }
                                  id={`negFeedbackTxt-select-${feedbackType}-${catIndex}-${index}`}
                                  label="negative feedback Txt"
                                />
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <>
                                <Tooltip
                                  title="Delete Negative Feedback Text"
                                  placement="top"
                                >
                                  <CloseIcon
                                    className="cursor-pointer"
                                    onClick={() =>
                                      deleteNegativeFeedbackText(
                                        catIndex,
                                        index
                                      )
                                    }
                                  />
                                </Tooltip>
                              </>
                            </Grid>
                          </Grid>
                        );
                      }
                    )}
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      type="button"
                      variant="text"
                      onClick={() => addNegativeFeedbackText(catIndex)}
                      sx={{
                        textTransform: "uppercase",
                      }}
                    >
                      <AddIcon />
                      add negative feedback text
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
            </>
          ) : (
            ""
          )} */}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default CategoryList;
